import Hero from './components/Hero';
import Services from './components/Services';
import Cases from './components/Cases';
import Stats from './components/Stats';
import Process from './components/Process';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '蜜桃传媒 | 官方品牌内容创作平台',
            description: '蜜桃传媒是专注于优质内容创作与品牌传播的新媒体平台，汇聚创意制作、短视频运营、社交媒体营销等核心业务',
            url: 'https://www.mitaomedia.com/',
          }),
        }}
      />
      <Hero />
      <Services />
      <Stats />
      <Cases />
      <Process />
      <FAQ />
    </main>
  );
}